/**
 * @file common.js
 */

import state from './state/index';
import mutations from './mutations/index';
import actions from './actions/index';

export default {
    state,
    mutations,
    actions
};
